const state = {
  sendNotificationResponse: {},
  allNotifications: [],
  error: {},
  adminNotifications: [],
  groupMessages: []
};

const mutations = {
  SEND_NOTIFICATION_SUCCESS(state, data) {
    state.sendNotificationResponse = data;
    state.sendNotificationResponse.status = true;
    setTimeout(() => {
      state.sendNotificationResponse = {};
    }, 3000);
  },
  SEND_NOTIFICATION_FAIL(state, data) {
    state.sendNotificationResponse = data;
    state.sendNotificationResponse.status = false;
    setTimeout(() => {
      state.sendNotificationResponse = {};
    }, 3000);
  },
  GET_NOTIFICATIONS_SUCCESS(state, data) {
    state.allNotifications = data;
  },
  GET_NOTIFICATIONS_FAIL(state) {
    state.error = {
      message: "Nie udało się pobrać powiadomień",
      status: false,
    };
  },
  SET_ADMIN_NOTIFICATIONS(state, notifications) {
    state.adminNotifications = notifications;
  },
  SET_GROUP_MESSAGES(state, messages){
    state.groupMessages = messages
  }
};

const getters = {
  getNotificationResponse: (state) => {
    return state.sendNotificationResponse;
  },
  getNotifications: (state) => {
    return state.allNotifications;
  },
  getAllAdminNotifications: (state) => {
    return state.adminNotifications;
  },
  getAllGroupMessages: state => state.groupMessages
};

export default {
  state,
  mutations,
  getters,
};
